export default __webpack_public_path__ + "static/media/Creditcard.e0a23c80.svg";